import { useSelector } from "react-redux";
import { Map } from "./Map";
import { Social } from "./Social";
import { getStoreId, getStores } from "../redux/selectors";

export const Footer = () => {
  const storeId = useSelector(getStoreId);
  const stores = useSelector(getStores);
  const currentStore = stores.find((store) => store._id === storeId);
  const contacts = currentStore?.contacts || null;
  const address =
    contacts?.find((contact) => contact.name === "address").description || null;
  const email =
    contacts?.find((contact) => contact.name === "e-mail").description || null;
  const phone =
    contacts?.find((contact) => contact.name === "phone").description || null;

  if (!contacts || !address || !email || !phone) {
    return null;
  }

  return (
    <div className="footer">
      {currentStore.title !== "Winnipeg" ? <Map /> : null}
      <div className="footer-contacts min-h-40">
        <h6 className="footer-header">Contact us:</h6>
        <p>
          <span className="footer-contacts-name">Address: </span>
          {address || null}
        </p>
        <p>
          <span className="footer-contacts-name">E-mail: </span>
          {email || null}
        </p>
        <p>
          <span className="footer-contacts-name">Phone: </span>
          {phone || null}
        </p>
        <div className="w-full flex justify-center">
          <Social position="footer" />
        </div>
      </div>
    </div>
  );
};
